import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeToHHmm',
  standalone: false
})
export class TimeToHHmmPipe implements PipeTransform {
  transform(val?: string | null): string {
    const raw = String(val ?? '');
    const m = raw.trim().match(/(\d{1,2}):(\d{2})(?:\s*(AM|PM))?/i);
    if (!m) return '99:99';
    let h = parseInt(m[1], 10);
    const mm = m[2];
    const ap = m[3]?.toUpperCase();
    const minuteNum = Number(mm);
    if (Number.isNaN(h) || Number.isNaN(minuteNum) || minuteNum < 0 || minuteNum > 59) {
      return '99:99';
    }
    if (ap) {
      if (h < 1 || h > 12) return '99:99';
      h = (h % 12) + (ap === 'PM' ? 12 : 0);
    }
    if (h < 0 || h > 23) return '99:99';
    return `${h.toString().padStart(2, '0')}:${mm}`;
  }
}
